<template>
  <v-card height="100%" v-once>
    <v-card-title primary-title>
      <div class="headline">{{labels.planInfo}}</div>
    </v-card-title>
    <div v-if="pa.planNo">
      <query-plan :planTitle="pa.planNo + ' - ' + query.plan"></query-plan>
    </div>
    <v-card-text v-else>
      No plan selected
    </v-card-text>
  </v-card>
</template>

<script>
import QueryPlan from '../../shared/plans/QueryPlan'
export default {
  data() {
    return {
      labels: {
        planInfo: 'Plan Information',
        selectedPlan: 'Selected Plan'
      }
    }
  },
  computed: {
    query() {
      return this.$store.state.agency.quotation.queryInfo
    },
    pa() {
      return this.$store.state.agency.quotation.paForm
    }
  },
  components: {
    QueryPlan
  }
}
</script>

<style>
</style>
